export default "__VITE_ASSET__X9rAF$OJ__"